import { RouteParams, RoutePath } from "src/routes";

export interface RoutePathParams<T extends RoutePath> {
    path: T;
    params: T extends keyof RouteParams ? RouteParams[T] : never;
}

export function buildUrl<T extends RoutePath>(
    path: T,
    params?: T extends keyof RouteParams ? RouteParams[T] : never
): string {
    let url: string = path;

    // Match parameter names in the path like :param or :param?
    const paramNames = url.match(/:[a-zA-Z]+(\?)?/g)?.map((p) => p.replace(/[:?]/g, "")) || [];

    for (const param of paramNames) {
        const rawValue = params?.[param as keyof typeof params];
        const value = rawValue != null ? String(rawValue) : "";

        const optionalWildcardStr = `/:${param}?/*`;
        const optionalStr = `/:${param}?`;
        const requiredStr = `/:${param}`;

        if (url.includes(optionalWildcardStr)) {
            url = url.replace(optionalWildcardStr, value ? `/${value}` : "");
        } else if (url.includes(optionalStr)) {
            url = url.replace(optionalStr, value ? `/${value}` : "");
        } else if (url.includes(requiredStr)) {
            url = url.replace(requiredStr, `/${value}`);
        }
    }

    return url;
}
